<template>
  <div class="operation-solution">
    <div class="solution-container">
      <div class="solution-content" ref="contentSection" :class="{ 'fade-in': isContentVisible }">
      <!-- 四化 -->
      <section class="service-intro">
        <div class="intro-content">
          <div class="intro-text">
            <p>管理制度化，工作流程化，作业规范化，考核指标化</p>
          </div>
        </div>
      </section>
   
      <!-- 运维管理组织体系图区域 -->
      <div class="organization-chart">
        <h3>{{ pageData.title }}</h3>
        <img :src="getFirstImageUrl(pageData.content)" :alt="pageData.title" class="org-image">
      </div>


      <div class="service-system">
        <h3>服务体系</h3>
        <div class="system-grid">
          <div v-for="(items, title) in systems" :key="title" class="system-card">
            <div class="card-header">
              <h4>{{ title }}</h4>
            </div>
            <ul>
              <li v-for="item in items" :key="item">{{ item }}</li>
            </ul>
          </div>
        </div>
      </div>
      <!-- 服务内容 -->
      <div class="it-service-system">
        <h3>服务内容</h3>
        <div class="service-parts">
          <div class="service-part" v-for="(service, index) in services" :key="index">
            <el-icon class="service-icon" v-if="service.icon === Phone">
              <Phone />
            </el-icon>
            <el-icon class="service-icon" v-if="service.icon === OfficeBuilding">
              <OfficeBuilding />
            </el-icon>
            <el-icon class="service-icon" v-if="service.icon === MostlyCloudy">
              <MostlyCloudy />
            </el-icon>
            <el-icon class="service-icon" v-if="service.icon === Sunset">
              <Sunset />
            </el-icon>
            <h4>{{ service.title }}</h4>
            <p>{{ service.description }}</p>
          </div>
        </div>
      </div>

      <!-- 服务目录 -->
      <div class="service-catalog">
        <h3>服务目录示例</h3>
        <div class="service-flow">
          <div v-for="service in services" :key="service.code" class="service-item">
            <div class="service-code">{{ service.code }}</div>
            <div class="service-content">
              <h4>{{ service.title }}</h4>
              <p>{{ service.description }}</p>
            </div>
            <div class="flow-arrow">
              <el-icon>
                <ArrowRight />
              </el-icon>
            </div>
          </div>
        </div>
      </div>

</div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue'
import { ArrowRight, Phone, OfficeBuilding, MostlyCloudy, Sunset } from '@element-plus/icons-vue'
import axios from 'axios'
import { mediaUrl } from "@/api/url"
import { articleGetDetail } from "@/api/court";

const pageData = ref({})

// 获取页面数据
const getPageData = async () => {
  try {
    const response = await articleGetDetail(
      12
    );
    console.log(response)
    if (response.data.code === 2000) {
      const data = response.data.data.data

      // 处理图片路径
      if (data.content) {
        // 使用正则表达式匹配所有的 img 标签的 src 属性
        const imgRegex = /<img[^>]*src="([^">]+)"/gi;

        data.content = data.content.replace(imgRegex, (match, src) => {
          const newSrc = `http://${mediaUrl}/media/${src}`;
          return match.replace(src, newSrc);
        });
      }

      pageData.value = data
    }
  } catch (error) {
    console.error('获取页面数据失败:', error)
  }
}

// 获取第一张图片的 URL
const getFirstImageUrl = (content) => {
  if (!content) return ''
  const imgMatch = content.match(/<img[^>]+src="([^">]+)"/i)
  return imgMatch ? imgMatch[1] : ''
}

const services = [
  {
    code: '0401',
    title: '基础环境运维服务',
    description: '对保证信息系统正常运行所必需的电力、空调、消防、安防等基础环境的运行维护管理，包括：机房电力、消防、安防等系统的例行检查及状态监控、响应支持、故障处理、性能优化等服务',
    icon: Phone
  },
  {
    code: '0402',
    title: '硬件运维服务',
    description: '对硬件设备（网络、主机、存储、桌面设备以及其他相关设备等）及其附带软件的例行检查及状态监控、响应支持、故障处理、性能优化等服务',
    icon: OfficeBuilding
  },
  {
    code: '0403',
    title: '软件运维服务',
    description: '对软件（包括基础软件、支撑软件、应用软件等）的功能修改完善、性能调优，以及常规的例行检查和状态监控、响应支持等服务',
    icon: MostlyCloudy
  },
  {
    code: '0405',
    title: '运维管理服务',
    description: '整体承担基础环境、硬件、软件、安全等综合性运维而提供的管理服务',
    icon: Sunset
  }
]

const systems = {
  '标准体系': [
    '运维管理制度',
    '运维工作流程',
    '运维作业规范',
    '运维管理指标'
  ],
  '工具平台': [
    'IT运维管理平台',
    '事件管理系统',
    '网络监控系统',
    '日志审计系统',
    '远程值班管理系统'
  ],
  '最佳实践': [
    '过程可监管',
    '结果可考核',
    '知识可继承',
    '模式可复制'
  ]
}

const isContentVisible = ref(false)
const contentSection = ref(null)

onMounted(() => {
  // 确保页面从顶部开始显示
  console.log('🔧 运维服务解决方案组件挂载，确保滚动到顶部')
  document.documentElement.scrollTop = 0
  document.body.scrollTop = 0
  window.scrollTo(0, 0)

  getPageData()

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.target === contentSection.value) {
        isContentVisible.value = entry.isIntersecting
      }
    })
  }, { threshold: 0.2 })

  if (contentSection.value) observer.observe(contentSection.value)

  return () => observer.disconnect()
})
</script>

<style lang="scss" scoped>
.operation-solution {
  padding: 60px 0;
  background: #f5f5f5;
  /* 使用柔和的背景色 */

  .solution-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
  }

  .organization-chart {
    margin-bottom: 60px;
    text-align: center;

    h3 {
      font-size: 24px;
      color: #333;
      margin-bottom: 20px;
    }

    .org-image {
      max-width: 100%;
      height: auto;
      border-radius: 12px;
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
      transition: all 0.3s ease;

      &:hover {
        transform: translateY(-5px);
        box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);
      }
    }
  }

  // 服务介绍样式
  .service-intro {
    // background: #fff;

    .intro-content {
      max-width: 1200px;
      margin: 0 auto;

      .intro-text {
        text-align: center;
        margin-bottom: 60px;
        max-width: 1200px;
        margin: 0 auto 60px;

        p {
          font-size: 18px;
          line-height: 1.8;
          color: #333;
          font-weight: 400;
          position: relative;
          padding: 30px 40px;
          background: #ffffff;
          border-radius: 12px;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);

          &::before {
            content: '"';
            position: absolute;
            top: 0;
            left: 20px;
            font-size: 60px;
            color: #2b5dff;
            opacity: 0.2;
            line-height: 1;
          }

          &::after {
            content: '"';
            position: absolute;
            bottom: -20px;
            right: 20px;
            font-size: 60px;
            color: #2b5dff;
            opacity: 0.2;
            line-height: 1;
          }
        }
      }

      .service-flow {
        margin-top: 60px;
        padding: 40px;
        background: #fff;
        border-radius: 16px;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);

        .service-items {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
          gap: 24px;
          row-gap: 30px;

          .service-item {
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 24px 16px;
            background: #f8f9fc;
            border-radius: 12px;
            transition: all 0.3s ease;
            cursor: pointer;

            &:hover {
              transform: translateY(-5px);
              background: #fff;
              box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);

              .el-icon {
                color: #fff;
                background: #2b5dff;
                transform: scale(1.1);
              }
            }

            .el-icon {
              font-size: 28px;
              color: #2b5dff;
              width: 60px;
              height: 60px;
              background: rgba(43, 93, 255, 0.1);
              border-radius: 12px;
              display: flex;
              align-items: center;
              justify-content: center;
              margin-bottom: 16px;
              transition: all 0.3s ease;
            }

            span {
              font-size: 16px;
              color: #333;
              text-align: center;
              font-weight: 500;
            }
          }
        }
      }
    }
  }

  .solution-content {
    opacity: 0;
    transform: translateY(20px);
    transition: all 0.6s ease;

    &.fade-in {
      opacity: 1;
      transform: translateY(0);
    }
  }
  .it-service-system {
    margin: 60px 0;
    text-align: center;

    h3 {
      font-size: 24px;
      color: #333;
      margin-bottom: 20px;
    }

    .service-parts {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      gap: 20px;

      .service-part {
        background: #ffffff;
        /* 使用白色背景 */
        border-radius: 12px;
        /* 圆角 */
        padding: 20px;
        text-align: center;
        width: 220px;
        /* 设置每个部分的宽度 */
        transition: all 0.3s;
        box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
        /* 添加阴影 */

        &:hover {
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
          /* 悬停时的阴影效果 */
          transform: translateY(-5px);
          /* 悬停时上移 */
        }

        .service-icon {
          font-size: 36px;
          color: #2b5dff;
          margin-bottom: 10px;
        }

        h4 {
          font-size: 18px;
          color: #333;
          margin-bottom: 5px;
        }

        p {
          font-size: 14px;
          color: #666;
        }
      }
    }
  }

  .background-section {
    background: #fff;
    padding: 40px;
    border-radius: 10px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
    margin-bottom: 40px;

    h3 {
      font-size: 24px;
      color: #333;
      margin-bottom: 20px;
      text-align: center;
    }

    p {
      font-size: 16px;
      color: #666;
      line-height: 1.8;
      margin-bottom: 16px;
    }
  }

  .service-catalog {
    margin-bottom: 60px;

    h3 {
      text-align: center;
      font-size: 24px;
      color: #333;
      margin-bottom: 40px;
    }

    .service-flow {
      display: flex;
      flex-direction: column;
      gap: 30px;
      max-width: 1000px;
      margin: 0 auto;

      .service-item {
        display: flex;
        align-items: center;
        background: #ffffff;
        /* 使用白色背景 */
        padding: 30px;
        border-radius: 12px;
        /* 圆角 */
        transition: all 0.3s;
        box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
        /* 添加阴影 */

        &:hover {
          transform: translateY(-5px);
          box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
        }

        .service-code {
          font-size: 24px;
          font-weight: bold;
          color: #2b5dff;
          margin-right: 20px;
          padding: 10px 20px;
          background: rgba(43, 93, 255, 0.1);
          border-radius: 4px;
        }

        .service-content {
          flex: 1;

          h4 {
            font-size: 18px;
            color: #333;
            margin-bottom: 10px;
          }

          p {
            font-size: 14px;
            color: #666;
            line-height: 1.6;
          }
        }

        .flow-arrow {
          color: #2b5dff;
          font-size: 24px;
          margin-left: 20px;
        }
      }
    }
  }

  .service-system {
    h3 {
      text-align: center;
      font-size: 24px;
      color: #333;
      margin-bottom: 40px;
    }

    .system-grid {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
      gap: 30px;
      max-width: 1200px;
      margin: 0 auto;
      padding: 0 20px;

      .system-card {
        background: #fff;
        border-radius: 12px;
        /* 圆角 */
        padding: 30px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
        transition: all 0.3s;

        &:hover {
          transform: translateY(-5px);
          box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
        }

        .card-header {
          margin-bottom: 20px;
          padding-bottom: 15px;
          border-bottom: 1px solid #eee;

          h4 {
            font-size: 18px;
            color: #333;
          }
        }

        ul {
          list-style: none;
          padding: 0;

          li {
            font-size: 14px;
            color: #666;
            margin-bottom: 12px;
            padding-left: 20px;
            position: relative;

            &:before {
              content: '';
              position: absolute;
              left: 0;
              top: 8px;
              width: 6px;
              height: 6px;
              background: #2b5dff;
              border-radius: 50%;
            }
          }
        }
      }
    }
  }
}

@media (max-width: 768px) {
  .operation-solution {
    padding: 40px 0;

    .service-flow {
      padding: 0 20px;
    }

    .system-grid {
      grid-template-columns: 1fr !important;
    }
  }
}
</style>